// extracted by mini-css-extract-plugin
export default {"select":"select--IASOq","name":"name--EEZEU"};